module.exports = __webpack_public_path__ + "static/images/containers/BuildingsCarousel/images/carousel-mask.1ce61256.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingsCarousel/images/carousel-mask.png
// module id = 2810
// module chunks = 11